<template>
  <div>
    <!-- Botão de remover -->
    <v-btn icon color="error" @click.prevent="dialog = true">
      <v-icon>mdi-trash-can-outline</v-icon>
    </v-btn>

    <!-- Dialog de confirmação -->
    <v-dialog v-model="dialog" max-width="520">
      <v-card>
        <v-card-title class="headline"> Confirmar remoção </v-card-title>
        <v-card-subtitle>Dados da visita</v-card-subtitle>
        <v-card-text class="body-1">
          <ul>
            <li>
              ID: <span class="font-weight-medium">#{{ visita.id }}</span>
            </li>
            <li>
              Data visita:
              <span class="font-weight-medium">{{ dataFormatada() }}</span>
            </li>
            <li>
              Produtor:
              <span class="font-weight-medium"
                >{{ visita.nome_produtor }} ({{ visita.matricula }})</span
              >
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading" @click="dialog = false">Cancelar</v-btn>
          <v-btn
            color="error"
            :loading="loading"
            :disabled="loading"
            @click="onConfirm"
          >
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
// Se usar moment global, pode formatar direto. Aqui uso Intl.DateTimeFormat para não depender de libs no componente.
export default {
  props: {
    visita: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  methods: {
    ...mapActions("visitaTecnica", ["removerVisita", "buscarVisitas"]),
    dataFormatada(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    async onConfirm() {
      this.loading = true;
      try {
        const ok = await this.removerVisita(this.visita);
        if (ok) {
          this.dialog = false;
          await this.buscarVisitas();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
